module.exports = __webpack_public_path__ + "img/wheat_nss1460.b39d4900.jpg";